module.exports = __webpack_public_path__ + "img/Armaan.a40374a9.jpg";